import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage, getReceiverManagementTranslation } from '../../hooks/useLanguage';

export const ReceiversTable = ({ receivers, isLoading, handleEdit, openDeleteModal }) => {
    const [isSpanish] = useLanguage();
    const [openDropdownId, setOpenDropdownId] = useState(null);
    return (
        <table className="min-w-full border-collapse border border-gray-300 mt-4 text-sm">
        <thead>
          <tr>
            <th className="border border-gray-300 p-2">{getReceiverManagementTranslation('receiverName', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getReceiverManagementTranslation('receiverTaxId', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getReceiverManagementTranslation('receiverEori', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getReceiverManagementTranslation('receiverAddress', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getReceiverManagementTranslation('receiverCity', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getReceiverManagementTranslation('receiverCountry', isSpanish)}</th>
            <th className="border border-gray-300 p-2">{getReceiverManagementTranslation('actions', isSpanish)}</th>
          </tr>
        </thead>
        <tbody>
          {receivers && receivers.length > 0 ? (
            receivers.map((receiver) => (
              receiver && (
                <tr key={receiver.id}>
                  <td className="border border-gray-300 p-2">{receiver.nombre}</td>
                  <td className="border border-gray-300 p-2">{receiver.nif}</td>
                  <td className="border border-gray-300 p-2">{receiver.eori}</td>
                  <td className="border border-gray-300 p-2">{receiver.direccion}</td>
                  <td className="border border-gray-300 p-2">{receiver.localidad}</td>
                  <td className="border border-gray-300 p-2">{receiver.pais}</td>
                  <td className="border border-gray-300 p-2 w-fit">
                    <div className='relative text-sm'>
                      <button 
                        className={`flex gap-2 justify-between items-center border-containera bg-gray-100 hover:bg-gray-200 rounded-full p-2 px-4 w-full`} 
                        onClick={() => {
                          const dropdownKey = `${receiver.id}`;
                          setOpenDropdownId(openDropdownId === dropdownKey ? null : dropdownKey);
                        }}
                        disabled={isLoading}
                      >
                        <p className='truncate'>{getReceiverManagementTranslation('selectAction', isSpanish)}</p>
                        <ChevronDown className={`w-4 h-4 ${openDropdownId === `${receiver.id}` && "rotate-180"}`} />
                      </button>
                      {openDropdownId === `${receiver.id}` && (
                        <div className='min-w-52 right-0 flex flex-col absolute z-10 bg-white mt-1 w-full border-containera shadow-md rounded-xl max-h-80 overflow-auto p-2'>
                          <p className='opacity-75 px-2 py-1 text-xs'>{getReceiverManagementTranslation('selectAction', isSpanish) || (isSpanish ? 'Seleccionar Acción' : 'Select Action')}</p>
                          <span 
                            className="px-2 py-1 hover:bg-gray-100 cursor-pointer rounded-full"
                            onClick={() => {
                              handleEdit(receiver);
                              setOpenDropdownId(null);
                            }}
                          >
                            {getReceiverManagementTranslation('edit', isSpanish)}
                          </span>
                          <span 
                            className='px-2 py-1 hover:bg-gray-100 cursor-pointer rounded-full' 
                            onClick={() => {
                              openDeleteModal(receiver);
                              setOpenDropdownId(null);
                            }}
                          >
                            {getReceiverManagementTranslation('delete', isSpanish)}
                          </span>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              )
            ))
          ) : (
            <tr>
              <td colSpan="7" className="border border-gray-300 p-2 text-center">
                {getReceiverManagementTranslation('noReceiversFound', isSpanish)}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    )
}